<template>

  <v-layout row wrap>
    <v-flex xs12 sm6 offset-sm3 class="mt-2">

      <div v-if="receivedIoTMessage.length">
        <v-card class="pa-3">
        <h3>最新の情報:</h3>
          <div v-for="(msg,msgIndex) in receivedIoTMessage" :key="'msgIndex'+msgIndex">
            <v-alert
                  :value="true"
                  :type="msg.type"
            >
              {{msg.text}}
            </v-alert>
              <v-img
                      :src="require('../assets/veryVerySorry.jpg')"
                      v-if="msg.veryVerySorry"
              >
              </v-img>
            <p>{{msg.timeStr}}</p>
          </div>

        </v-card>
      </div>


      <v-flex xs12 pa-2 v-if="userSelect.service.name=='adt'">
        <div v-if="showArrivalButton">
          <p class="title" v-if="!buttonPressed">お店の前に<span class="font-weight-bold">着いたら</span>
            下のボタンを押して、お店の人に到着を知らせてください</p>
          <v-btn block round large color="orange"  @click="arrivedPressed('customerArrived')"
                 v-if="!buttonPressed">お店の前に到着しましたよ</v-btn>
          <div v-if="buttonPressed" class="text-xs-center">
            <p>お店に通知しました。車内でお待ちください。</p>

          </div>
          <div v-if="showCancelCustomerArrived">
            間違えてボタンを押してしまいましたか?<br />
            <v-btn small @click="arrivedPressed('cancelCustomerArrived')">到着通知をキャンセル</v-btn>
          </div>



        </div>
     </v-flex>

      <v-flex xs12 pa-2 v-if="isCaptured">
        <home-message :serviceType="userSelect.service.name"></home-message>
      </v-flex>



      <div v-if="replyFromShop">
        <v-card class="pa-3">
          <p>お店から返信がありました</p>
          <h3>{{replyFromShop}}</h3>
        </v-card>
      </div>



      <div v-if="statusHistory.length == 1 " class="ma-3 font-weight-bold">
          <v-alert
                  :value="true"
                  type="warning"
          >
              <h3>注文は確定していません。お店からの回答を待っています。</h3>
          </v-alert>

        最大3分待ってもお店からの回答がない場合は、ブラウザで画面を再読込(リロード)して、画面最下部の「ご注文履歴」ボタンからお確かめください。
      </div>

      <p class="mt-4">ご注文の内容は次の通りです。</p>
      <h3 class="pa-1">お受取日時</h3>
      <v-card class="text-xs-center" flat>
        <p>受信日時:<span class="subheading font-weight-medium ">
                    {{userSelect.day.dayTextLang}} {{userSelect.time}}</span><br />
          お受取方法:<span class="headline font-weight-medium ">
                    {{userSelect.service.langName}}</span><br />
          お客様名:<span class="headline font-weight-medium ">
                    {{userSelect.name}} さま
                </span><br/>
          Email: {{userSelect.email}}</p>
        <p v-if="userSelect.service.name=='adt'" >
          車種:<span class="headline">{{userSelect.carType}}</span>
          <v-btn :color="userSelect.carColor">車両の色</v-btn>
          <br />
          ナンバー:<span class="headline">{{userSelect.carPlate}}</span>

        </p>
        <p v-if="userSelect.service.name=='dineIn'">
          来店お客様人数:<span>{{userSelect.numOfGuest}}名様</span>
        </p>
      </v-card>

      <h3 class="pa-1">ご注文内容</h3>
      <h3 class="mt-3">合計金額{{totalPriceCurrency}}</h3>
      <v-list two-line >
        <template v-for="(item) in cart.items">

          <v-list-tile
                  :key="item.cartItemId"
                  avatar
          >
            <v-list-tile-avatar tile size="50" class="mr-1">
              <img :src="item.image" class="avatar_photos">
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title v-html="item.nameWithOption" class="cart_item"></v-list-tile-title>
              <v-list-tile-sub-title>{{ formattedPrice(item.price) }}</v-list-tile-sub-title>
            </v-list-tile-content>


          </v-list-tile>

        </template>
      </v-list>

      <h3 class="pa-1">お取引記録</h3>
      <v-list two-line v-for="(obj,statusIndex) in statusHistory" :key="'statusIndex'+statusIndex">
        <v-list-tile
                :key="obj.status"
        >
          <v-list-tile-content>
            <v-list-tile-title v-html="timeFormat(obj.json)" class="cart_item"></v-list-tile-title>
            <v-list-tile-sub-title>{{ obj.statusTransalated }}</v-list-tile-sub-title>
          </v-list-tile-content>

        </v-list-tile>
        <v-divider></v-divider>
      </v-list>

    </v-flex>
  </v-layout>
</template>

<script>
  import  { Logger } from 'aws-amplify';
  const logger = new Logger('OrderDetail','INFO');
  import { AmplifyEventBus } from 'aws-amplify-vue'
  import moment from 'moment-timezone'
  import HomeMessage from '../components/HomeMessage'
  import {PriceMixIns} from '../mixins/price'

  export default {
    components: {'HomeMessage': HomeMessage, },
    mixins: [PriceMixIns],
    data() {
      return {
        orderId:undefined,
        receivedIoTMessage:[],
        orderDetail: {},
        cognitoId:"",
        lang:undefined,
        currency:undefined,
        cart:{items:[]},
        userSelect:{
          service:{
            name:undefined,
            langName:""
          },
          day:{
            dayText:"",
            dayTextLang:"",
            selectedNum:undefined
          },
          time:"",
          name:"",
          email:"",
          carType:"",
          carPlate:"",
          carColor:"",
          numOfGuest:""
        },
        totalPrice:0,
        totalPriceCurrency:"",
        statusHistory:[],
        buttonPressed:false,
        showCancelCustomerArrived:false,
        showArrivalButton:false,
        replyFromShop:false,
        isCaptured:false,
          refundedShown:false,
      }
    },
    created(){
      AmplifyEventBus.$on("cognitoId",this.cognitoIdReceived)
      AmplifyEventBus.$on("mqttMessage",this.mqttMessageReceived)
    },
    beforeDestroy () {
        AmplifyEventBus.$off("cognitoId",this.cognitoIdReceived)
        AmplifyEventBus.$off("mqttMessage",this.mqttMessageReceived)
    },
    async mounted() {
      AmplifyEventBus.$emit('setBackTo', "/history")
      AmplifyEventBus.$emit('setBottomBar', "history" )
      AmplifyEventBus.$emit('getCognitoId')
      this.orderId = this.$route.query.orderId
        this.$store.commit("setCurrentOrderMT",{})
      const apiUrl = "https://24d3ujue09.execute-api.ap-northeast-1.amazonaws.com/default/adt-consumers/orderDetail"
      const dataToSend = {}
      dataToSend.request = "orderDetail"
      dataToSend.orderId = this.orderId
      dataToSend.hostname = location.hostname
      dataToSend.cognitoIdentity = this.cognitoId
      logger.info("orderDetail to send",dataToSend)
      const res = await this.axios.post(apiUrl,dataToSend)
      logger.info("orderDetail received",res.data)
        this.$store.commit("setCurrentOrderMT",res.data)
        if(res.data.dataToSend && res.data.dataToSend.dp){
            logger.info("dp found. going to orderDetailDp")
            this.$router.push("/orderDetailDp?orderId="+this.orderId)
        }
      this.lang = res.data.dataToSend.lang
      this.currency = res.data.dataToSend.currency
      this.cart = res.data.dataToSend.cart
      this.totalPrice = this.cart.total
      this.totalPriceCurrency = this.getCurrencyFormatted(this.totalPrice);
      this.userSelect = res.data.dataToSend.userSelect
      this.statusHistory = this.sortStatusHistory(res.data.statusHistory)
      this.trackPage('/orderDetail/')
      // show button only after captured
      if(this.statusHistory[0].status == "captured"
      ||this.statusHistory[0].status == "cancelCustomerArrived"){
        this.showArrivalButton = true
      }
      if(this.statusHistory[0].status == "captured"){
        this.isCaptured = true
      }
      // if too old, remove arrival button
      for(let i in this.statusHistory){
        const record = this.statusHistory[i]
        if(record.status == "captured"){
          if(record.json.timestamp + 60 * 60 * 24 * 1000 < Date.now() ){
            this.showArrivalButton = false
            logger.info("captured date is more than 24 hours before. Hide arrival button")
          }
        }
      }
      // show replyFromShop_
      const charToSubstr = "arrivalReplyFromShop_"
      if(this.statusHistory[0].status.substring(0,charToSubstr.length) == charToSubstr){
        const replyMsgArray = this.statusHistory[0].status.split("_")
        this.replyFromShop = replyMsgArray[1]
      }else{
        this.replyFromShop = false
      }

        AmplifyEventBus.$emit('setJourney', {key:"page",value:"注文履歴 "+this.orderId} )

    },
    methods: {
      mqttMessageReceived:function(data){
        if(data.orderId == this.orderId){
          logger.info("message for this oderId",data)
            AmplifyEventBus.$emit('setJourney', {key:"mqtt",value:data } )
          const message = {}
          message.timestamp = Date.now()
          message.timeStr = moment(message.timestamp).tz("Asia/Tokyo").format('llll:s')

            //add to statusHistory
            if(data.result){
                const obj = {}
                obj.status = data.result
                obj.statusTransalated = this.translateStatusHistory(data.result)
                obj.json = {}
                obj.json.timestamp = message.timestamp
                this.statusHistory.unshift(obj)
            }




          if(data.type == "arrivalReplyFromShop"){
            message.text = data.actionText
              message.type = "success"
          }else if(data.type == "answerOrder"){



            if(data.result == "captured"){
              message.text = "おめでとうございます。お店が注文を承諾しました。"
                message.type = "success"
              this.showArrivalButton = true
                this.isCaptured = true
                AmplifyEventBus.$emit('setJourney', {key:"orderStatus",value:"captured"} )
            }else if(data.result == "refunded" && !this.refundedShown){
                this.refundedShown = true
              message.text = "すみません。お店が注文をお受けできないそうです。"
                message.type = "error"
                message.veryVerySorry = true
                AmplifyEventBus.$emit('setJourney', {key:"orderStatus",value:"refunded"} )
            }else if(data.result == "refunded_dp" && !this.refundedShown){
                this.refundedShown = true
                message.text = "すみません。配送会社が注文をお受けできないそうです。"
                message.type = "error"
                message.veryVerySorry = true

            }
          }
            this.receivedIoTMessage.unshift(message)
        }
      },
      cognitoIdReceived:function(data){
        logger.info("cognitoId",data)
        this.cognitoId = data
      },

      formattedPrice:function(priceNaked){
        return this.getCurrencyFormatted(priceNaked)
      },
      sortStatusHistory(historyObj){
        const statusHistoryArray = []
        for(let i in historyObj){
          const obj = {}
          obj.status = i
          obj.json = JSON.parse(historyObj[i])
          obj.statusTransalated = this.translateStatusHistory(i)
          statusHistoryArray.push(obj)
        }
        statusHistoryArray.sort(compareStatusHistoryArray)
        logger.info("statusHistoryArray",statusHistoryArray)
        return statusHistoryArray

      },
      translateStatusHistory:function(key){
        const charToSubstr = "arrivalReplyFromShop_"
        if(key.substring(0,charToSubstr.length) == charToSubstr) {
          const replyMsgArray = key.split("_")
          return replyMsgArray[1]
        }else{
          switch(key) {
            case "cancelCustomerArrived":
              return "到着通知キャンセル"
            case "customerArrived":
              return "到着通知"
            case "placed":
              return "注文受信/カード与信確保"
            case "refunding":
              return "返金開始"
            case "refunded":
              return "返金完了"
            case "accepted":
              return "注文承諾"
            case "denied":
              return "注文拒否"
            case "capturing":
              return "カード決済開始"
            case "captured":
              return "カード決済完了"
            default:
              return key
          }
        }
      },
      timeFormat(json){

        moment.locale(this.lang)
        return moment(json.timestamp).tz("Asia/Tokyo").format('llll:s')
      },
      arrivedPressed:async function(mode){
        // mode: customerArrived / cancelCustomerArrived
        logger.info("arrivedPressed",mode)
        this.buttonPressed = true
        const apiUrl = "https://24d3ujue09.execute-api.ap-northeast-1.amazonaws.com/default/adt-consumers/customerArrived"
        const dataToSend = {}
        dataToSend.request = mode
        dataToSend.orderId = this.orderId
        dataToSend.hostname = location.hostname
        dataToSend.cognitoIdentity = this.cognitoId
        dataToSend.customerEmail =  this.userSelect.email
        logger.info("arrivedPressed to send",dataToSend)
        const res = await this.axios.post(apiUrl,dataToSend)
        if(res.data.result == "success"){
          if(mode=="customerArrived"){
            this.showCancelCustomerArrived=true
            this.buttonPressed = true
          }else if(mode=="cancelCustomerArrived"){
            this.showCancelCustomerArrived=false
            this.buttonPressed = false
          }

          AmplifyEventBus.$emit(mode,this.cart.premiseName)

        }else{
          this.buttonPressed = false
        }
      },

    },
    computed:{
      messageAfterCaptureData(){
        let res = {}
        if(this.$store.state.menu.messageAfterCapture
        && this.$store.state.menu.messageAfterCapture.data
        ){
          return this.$store.state.menu.messageAfterCapture.data
        }
        return res
      }
    },
  }

  const compareStatusHistoryArray = (a,b) => {
    const dateA = a.json.timestamp
    const dateB = b.json.timestamp
    let comparison = 0
    if(dateA < dateB){
      comparison = 1
    }else if(dateA > dateB){
      comparison = -1
    }
    return comparison
  }
</script>